import * as React from "react";
const SvgFiRrWaterBottle = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M20 7.989A3.98 3.98 0 0 0 17.485 4.3L15 3.307V2a1 1 0 1 0 0-2H9a1 1 0 0 0 0 2v1.307L6.514 4.3A4 4 0 0 0 5.383 11a3.993 3.993 0 0 0 0 6A4.006 4.006 0 0 0 8 24h8a4.006 4.006 0 0 0 2.618-7 3.994 3.994 0 0 0 0-6A4 4 0 0 0 20 7.989M18 20a2 2 0 0 1-2 2H8a2 2 0 1 1 0-4h8a2 2 0 0 1 2 2m0-6a2 2 0 0 1-2 2H8a2 2 0 1 1 0-4h8a2 2 0 0 1 2 2M8 10a2 2 0 0 1-.743-3.841l3.114-1.246A1 1 0 0 0 11 3.984V2h2v1.984a1 1 0 0 0 .629.929l3.113 1.245A2 2 0 0 1 16 10z"
    />
  </svg>
);
export default SvgFiRrWaterBottle;
